import { LSWidgetElement } from "@data-types/live-widget/LSwidgetElement";
import { LiveWidgetTypes } from "@data-types/live-widget/LiveWidgetTypes";

export const isLSWidget = (widget: any): widget is LSWidgetElement =>
	widget?.type === LiveWidgetTypes.LS;
